import axios from "axios";

export const getDaftarAsdp = async (plat) => {
  return await axios.post(
    `${process.env.VUE_APP_API_URL}/etle/api/daftar_konfirmasi_asdp.php?platnomor=${plat}`,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    },
  );
};
